module.exports = __webpack_public_path__ + "src/assets/games/10/247.jpg";